export const boundBoxToPolygon = (
  { north, west, south, east }: google.maps.LatLngBoundsLiteral,
  increaseFactor = 0.25
) => {
  const deltaLat = increaseFactor * (north - south);
  const deltaLng = increaseFactor * (east - west);
  const [newNorth, newSouth, newEast, newWest] = [
    north + deltaLat,
    south - deltaLat,
    east + deltaLng,
    west - deltaLng,
  ];
  return [
    [
      [newWest, newNorth],
      [newEast, newNorth],
      [newEast, newSouth],
      [newWest, newSouth],
      [newWest, newNorth],
    ],
  ];
};
